module.exports = "<span ng-message=required>* Required</span> <span ng-message=min>* value too small</span> <span ng-message=max>* value too large</span> ";